import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEditWrite = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 22,
	height: 23,
	viewBox: "0 0 22 23",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		stroke: "#000",
		strokeLinejoin: "round",
		strokeWidth: 2,
		children: [/* @__PURE__ */ _jsx("path", {
			strokeLinecap: "round",
			d: "m17 1 4 4.098-16 16.39H1V17.39zM21 21.488H11"
		}), /* @__PURE__ */ _jsx("path", {
			strokeLinecap: "square",
			d: "M14.5 4.073 18 7.66"
		})]
	})
});
export default SvgEditWrite;
